import React, { useState } from 'react';
import { Form } from 'react-bootstrap';

const GenericFileUpload = ({ 
  onFileSelect, 
  acceptedTypes = ['application/pdf', 'image/jpeg', 'image/png'], 
  maxSize = 10 * 1024 * 1024, // 10MB by default
  placeholder = "Seleziona un file..."
}) => {
  const [dragOver, setDragOver] = useState(false);

  const validateFile = (file) => {
    // Check file size
    if (file.size > maxSize) {
      return `Il file è troppo grande. Dimensione massima: ${(maxSize / (1024 * 1024)).toFixed(1)}MB`;
    }
    
    // Check file type
    if (!acceptedTypes.includes(file.type)) {
      const acceptedExtensions = acceptedTypes.map(type => {
        switch(type) {
          case 'application/pdf': return 'PDF';
          case 'image/jpeg': return 'JPG';
          case 'image/png': return 'PNG';
          case 'application/msword': return 'DOC';
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': return 'DOCX';
          default: return type;
        }
      }).join(', ');
      return `Tipo di file non supportato. Sono accettati: ${acceptedExtensions}`;
    }
    
    return null;
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    handleFileSelection(selectedFile);
  };

  const handleFileSelection = (file) => {
    if (file) {
      const error = validateFile(file);
      if (error) {
        onFileSelect?.(null, error);
      } else {
        onFileSelect?.(file, null);
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFileSelection(files[0]);
    }
  };

  return (
    <div
      className={`border rounded p-3 text-center ${dragOver ? 'border-primary bg-light' : 'border-dashed'}`}
      style={{ 
        borderStyle: 'dashed',
        cursor: 'pointer',
        minHeight: '120px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={() => document.getElementById('file-input').click()}
    >
      <i className="fas fa-cloud-upload-alt fa-2x text-muted mb-2"></i>
      <p className="text-muted mb-1">
        Trascina un file qui o clicca per selezionare
      </p>
      <small className="text-muted">
        Dimensione massima: {(maxSize / (1024 * 1024)).toFixed(1)}MB
      </small>
      
      <Form.Control
        id="file-input"
        type="file"
        accept={acceptedTypes.join(',')}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default GenericFileUpload;
